module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18.4 17.7V5H.6v13h18.2l-.4-.3zM1.6 6h15.8v11L13 13.7l-2.3 1.7L7 11.5 1.8 17h-.2V6z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"9.7","cy":"5.4","fill":"#39b54a","r":"5"}}),_c('path',{attrs:{"d":"M11.5 4.5h-1.2V3.3c0-.3-.2-.5-.5-.5h-.6c-.3 0-.5.2-.5.5v1.2H7.5c-.3 0-.5.2-.5.5v.6c0 .2.2.4.5.4h1.2v1.2c0 .3.2.5.5.5h.6c.3 0 .5-.2.5-.5V6h1.2c.3 0 .5-.2.5-.5V5c-.1-.3-.3-.5-.5-.5z","fill":"#58595b"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/add_image.svg
// module id = 693
// module chunks = 2